import { HttpApiSchema } from "@effect/platform";
import { Schema } from "effect";

/** The target id is missing or belongs to another account; callers read it as null. */
export class SystemNotFound extends Schema.TaggedError<SystemNotFound>()(
  "SystemNotFound",
  { message: Schema.String },
  HttpApiSchema.annotations({ status: 404 }),
) {}

/** An id the request refers to (not its target) is missing or belongs to another account. */
export class SystemReferenceNotFound extends Schema.TaggedError<SystemReferenceNotFound>()(
  "SystemReferenceNotFound",
  { code: Schema.Literal("NOT_FOUND"), message: Schema.String },
  HttpApiSchema.annotations({ status: 404 }),
) {}

export class SystemConflict extends Schema.TaggedError<SystemConflict>()(
  "SystemConflict",
  { code: Schema.Literal("CONFLICT"), message: Schema.String },
  HttpApiSchema.annotations({ status: 409 }),
) {}
